export const MOVIE = 'movie'
export const AD = 'ad'
export const HIGHLIGHT = 'highlight'
export const WEISCHER = 'weischer'
export const ADVERTISEMENT  = 'advertisement'